/** General Trade Organization Dashboard — dispute ledger + baseline only. */
import TradeOrgShell from "../../TradeOrgShell";
import DisputeLedgerPanel from "../../widgets/DisputeLedgerPanel";

const ACCENT = "#4EC1E4";   // teal — general trade orgs (distinct from producer amber)

export default function GeneralDashboard() {
  return (
    <TradeOrgShell variantName="General" accent={ACCENT}>
      {({ org, quorum }) => (
        <DisputeLedgerPanel org={org} quorum={quorum} accent={ACCENT} />
      )}
    </TradeOrgShell>
  );
}
